const DefaultContainer = () => import('@/containers/DefaultContainer');

const aes_envelopestats = () => import('./index');
const edit = () => import('./components/edit/index');
const add = () => import('./components/add/index');

const aes_envelopestatRoute = {
  path: '/aes_envelopestats',
  component: DefaultContainer,
  children: [
    {
      path: '',
      name: 'Envelope Statistics',
      component: aes_envelopestats
    },
    {
      path: '/aes_envelopestat/:id',
      name: 'aes_envelopestatEdit',
      meta: { label: 'Edit' },
      component: edit,
    },
    {
      path: '/aes_envelopestat/add',
      name: 'aes_envelopestatAdd',
      meta: { label: 'Add' },
      component: add,
    }
  ]
};

export default aes_envelopestatRoute;
